import { createReducer } from 'redux-starter-kit';

import { BriefingsReducerType } from './briefings.types';
import {
  SET_BRIEFINGS,
  CLEAR_BRIEFINGS,
  SET_BRIEFING,
  CLEAR_BRIEFING,
} from './briefings.actions';

const initialState: BriefingsReducerType = {
  list: {
    count: -1,
    next: '',
    previous: '',
    results: [],
  },
  selected: {
    id: -1,
    name: '',
    json: {},
  },
};

export default createReducer(initialState, {
  [SET_BRIEFINGS]: (state, action) => {
    state.list = action.payload;
  },
  [CLEAR_BRIEFINGS]: (state) => {
    state.list = initialState.list;
  },
  [SET_BRIEFING]: (state, action) => {
    state.selected = action.payload;
  },
  [CLEAR_BRIEFING]: (state) => {
    state.selected = initialState.selected;
  },
});
